var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditButtonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#F2F4F7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.016 -147.342) scale(0.26056)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.6,645.8h3.9l25.8-25.8l-3.9-3.9l-25.8,25.8V645.8z M124.4,652.1v-12.7l36.3-36.2c0.6-0.5,1.2-0.9,1.9-1.2   c0.7-0.3,1.4-0.4,2.2-0.4c0.8,0,1.5,0.1,2.2,0.4c0.7,0.3,1.4,0.7,1.9,1.3l4.5,4.5c0.6,0.5,1,1.2,1.3,1.9c0.3,0.7,0.4,1.5,0.4,2.2   c0,0.8-0.1,1.5-0.4,2.2c-0.3,0.7-0.7,1.3-1.3,1.9l-36.2,36.2H124.4z M168.5,611.8l-3.9-3.9L168.5,611.8z M158.3,618.1l-1.9-2   l3.9,3.9L158.3,618.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButtonIcon);
export default __webpack_public_path__ + "static/media/editButtonIcon.5a8a46ffac1b6ea869748528dba21656.svg";
export { ForwardRef as ReactComponent };